import axios, { AxiosInstance } from 'axios'
import Cookies from 'js-cookie'
import { generateApiUrlByVersion } from './custom'

const baseURL = generateApiUrlByVersion(1)
const authToken = Cookies.get('tokenPayload') ?? process.env.REACT_APP_ARO_API_AUTH_TOKEN

const aroAPI: AxiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + authToken,
  }
})

export default aroAPI
